/**
 * ONVIF API service for cloud frontend.
 * All calls go through /api/nodes/:nodeId/cameras/:cameraId/onvif/...
 */
import axios from 'axios';

const API_BASE = window.location.origin + '/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 35000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cloud_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cloud_token');
      if (!window.location.pathname.startsWith('/login')) window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

function base(nodeId: string, cameraId: string) {
  return `/nodes/${nodeId}/cameras/${cameraId}/onvif`;
}

export async function registerCamera(nodeId: string, cameraId: string, creds: { ip: string; port: number; username: string; password: string }) {
  const resp = await api.post(`${base(nodeId, cameraId)}/register`, creds);
  return resp.data;
}

export async function getConfig(nodeId: string, cameraId: string) {
  const resp = await api.get(`${base(nodeId, cameraId)}/config`);
  return resp.data.data;
}

export async function getCapabilities(nodeId: string, cameraId: string) {
  const resp = await api.get(`${base(nodeId, cameraId)}/capabilities`);
  return resp.data;
}

export async function updateNetwork(nodeId: string, cameraId: string, version: number, network: any) {
  const resp = await api.put(`${base(nodeId, cameraId)}/config/network`, { version, network });
  return resp.data;
}

export async function updateImaging(nodeId: string, cameraId: string, version: number, imaging: any) {
  const resp = await api.put(`${base(nodeId, cameraId)}/config/imaging`, { version, imaging });
  return resp.data;
}

export async function updateEncoding(nodeId: string, cameraId: string, version: number, encoding: any) {
  const resp = await api.put(`${base(nodeId, cameraId)}/config/encoding`, { version, encoding });
  return resp.data;
}

export async function updateOverlay(nodeId: string, cameraId: string, version: number, overlay: any) {
  const resp = await api.put(`${base(nodeId, cameraId)}/config/overlay`, { version, overlay });
  return resp.data;
}

export async function sendPTZ(nodeId: string, cameraId: string, command: any) {
  const resp = await api.post(`${base(nodeId, cameraId)}/ptz`, command);
  return resp.data;
}
